import "./Overgame.scss";
import Spinner from "../components/shared/Spinner/Spinner";
import ToastService from "../Services/ToastService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../App/store";
import { useEffect, useMemo, useState } from "react";
import { openPopup } from "../App/Slices/popupSlice";
import GameClosed from "../components/shared/GameClosed/GameClosed";

export const OverGame = () => {
  const gameSelector = useSelector((state: RootState) => state.game);
  const [usersReady, setUsersReady] = useState<boolean>(false);

  const dispatch = useDispatch();
  const [gameReadyCounter, setGameReadyCounter] = useState<number>(1);

  const handleBackLobby = () => {
    ToastService.loading("Returning to the lobby ...", {
      duration: 5000,
    });

    setTimeout(() => {
      window.location.reload();
    }, 5050);
  };

  useEffect(() => {

    if (usersReady || gameReadyCounter < 0) return;

    let initialCounter =
      gameSelector.game?.game_settings?.connection_timeout || 0;

    const absolute_time = new Date(
      gameSelector?.game?.absolute_time || new Date()
    );
    absolute_time.setSeconds(absolute_time.getSeconds() + 5);
    
    if (gameReadyCounter == 0) {
      dispatch(openPopup(<GameClosed></GameClosed>));
    } else
      setTimeout(() => {
        setGameReadyCounter(
          initialCounter -
            (initialCounter -
              Math.ceil(
                (absolute_time.getTime() - new Date().getTime()) / 1000
              ))
        );
      }, 1000);
  }, [gameReadyCounter]);

  useEffect(() => {
    if (usersReady) return;

    if (gameSelector.game?.status == "ACTIVE") {
      setUsersReady(true);
      return;
    }
    const usersCount = gameSelector.game?.status_of_players?.filter(
      (player) => player.status == 1
    ).length;

    setUsersReady(usersCount == gameSelector.game?.players?.length);
  }, [gameSelector.game]);

  const ReadyCounterRender = useMemo(() => {
    return (
      <div className="ReadyCounter">
        <span className="ReadyCounter__info">
          Game will close in
          <span className="ReadyCounter__info--count">{gameReadyCounter}</span>
          seconds if there is only one person left
        </span>
      </div>
    );
  }, [gameReadyCounter]);

  return (
    <div className="OverGame">
      <div className="BackToLobby">
        <div>Game ID: {gameSelector?.game?._id} </div>
        <button onClick={handleBackLobby}>Back to the lobby</button>
      </div>
      {!usersReady ? (
        <div className="PlayerStatuses">
          <h2>Players</h2>
          {gameSelector?.game_players?.map((player) => (
            <div className="PlayerStatuses__player" key={player._id}>
              <div className="PlayerStatuses__player--status">
                {gameSelector?.game?.status_of_players?.find(
                  (item) => item.player == player._id
                )?.status ? (
                  <span className="material-symbols-outlined">check</span>
                ) : (
                  <Spinner size={2.5} color="red" renderContent=""></Spinner>
                )}

                <img
                  src={
                    player?.image || "/assets/game/BattleSnailPlaceholder.png"
                  }
                ></img>
                <span>{player.nick_name} </span>
              </div>
            </div>
          ))}
          {ReadyCounterRender}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default OverGame;
